import { useAuth as useClerkAuth } from '@clerk/react'

// Thin Clerk-backed shim. Keeps the SAME `useAuth()` shape the app already
// consumes ({ session, loading }) so callers don't change. Clerk's
// <ClerkProvider> (in main.tsx) supplies the context, so there's no longer a
// local AuthProvider component here.
export function useAuth() {
  const { isLoaded, isSignedIn, userId } = useClerkAuth()
  return {
    loading: !isLoaded,
    session: isSignedIn && userId ? { userId } : null,
  }
}
